import moment from 'moment'

moment.locale('en')
moment.updateLocale('en', {
  week: {
    // First day of week is Monday
    dow: 1,
    // First week of year must contain 4 January (7 + 1 - 4)
    doy: 4
  }
})
